import CustomerBlockEnum from '../enumerators/customer-block.enum'

export default class CustomerBlockListComponent {
    constructor() {
        this.init()
        if (window.matchMedia('(max-width: 1000px)').matches) {
            this.toggleModal()
        }
    }

    init() {
        $(document).ready(() => {
            CustomerBlockListComponent.dataLayer()
            updateResetStatus()

            $(document).on('facetwp-loaded', async () => {
                if (FWP.loaded) {
                    $(document).trigger('iris-map/map/load')
                    updateResetStatus()
                    CustomerBlockListComponent.dataLayer()
                }
            })

            function updateResetStatus() {
                const isQuery = FWP.buildQueryString()
                const target = '.facetwp-reset'
                if (isQuery && !$(target).hasClass('is-active')) {
                    $('.facetwp-reset').addClass('is-active')
                } else if (!isQuery && $(target).hasClass('is-active')) {
                    $('.facetwp-reset').removeClass('is-active')
                }
            }
        })
    }

    toggleModal() {
        $(document).on('click', CustomerBlockEnum.BLOCK_LIST_MAP_TRIGGER, () => {
            $('body').toggleClass('customer-list-map-open')
        })

        $(document).on('click', CustomerBlockEnum.BLOCK_LIST_ENGINE_TRIGGER, () => {
            $('body').toggleClass('customer-list-engine-open')
        })
    }

    static dataLayer() {
        $(document).on('click', CustomerBlockEnum.BLOCK_LIST_CARD_INFOBOX, function (e) {
            dataLayer.push({
                event: 'customer_click_card_infobox',
                cardTitle: $(this).find('.iris-card__content__title a').text().trim(),
            })
        })
    }
}
